﻿/* 
Object:         Group configuration
Description:    Logic and events for the module Group Configuration 
Used in:        Group configuration
*/

/*---[ ESLint ]---*/
/*
    global _msg_notsaved: true, 
           groupconfiguration
*/

window.groupconfiguration = function () {

    var LABEL_YES = "";
    var LABEL_NO = "";
    var LABEL_DELETE = "";

    var MIN_OCCUPANCY_HIGH = "";
    var MIN_OCCUPANCY_LOW = "";

    /**
    * Delete group
    * @param {number} groupId
    */
    function deleteGroup(groupId) {

        $.ajax({
            type: "GET",
            url: appsettings.getUrl("Group/DeleteGroup?groupId=" + groupId),
            success: function (responseData) {

                if (responseData != undefined && responseData != null) {
                    if (responseData.Succesfully == false) {
                        main.openActionsDialog(' ', responseData.Message,
                            [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    }
                }

                navigation.navigateToSpecificUrl("Group/Overview");
            }
        });
    }


    return {

        /**
        * Init (binding button actions)
        */
        initialize: function (labelYes, labelNo, labelDelete) {

            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("Group/Add");
            });

            LABEL_YES = labelYes;
            LABEL_NO = labelNo;
            LABEL_DELETE = labelDelete;
        },

        /**
        * Update Item from the grid.
        * @param {Object} e
        */
        editItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // dataItem
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            
            // Edit mode form
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Group/Edit_Tabstrip?groupId=" + dataItem.GroupID + "&breadcrumbLabel=" + escape(dataItem.Label));
        },

        /**
        * Show Item from the grid
        * @param {Object} e
        */
        showItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // dataItem
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Show mode form 
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Group/Show_Tabstrip?groupId=" + dataItem.GroupID + "&breadcrumbLabel=" + escape(dataItem.Label));
        },

        /**
        * Delete Item from the grid
        * @param {Object} e
        */ 
        deleteItem: function (e) {
            var event = e;
            var data = this;

            function callbackYes(event, data) {
                // Prevent default behaviour
                event.preventDefault();
                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));
                deleteGroup(dataItem.GroupID);
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });
        },



        /**
        * Validation Form 
        * @param {Object} e
        */
        onFormValidateField: function (e) {},

        /**
        * Submit Form 
        * @param {Object} e
        */
        onFormSubmit: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            e.model.TimeCalculation = $("#TimeCalculation").data("kendoTimePicker").element[0].value;
            e.model.SchedulerInfoSuppressFrom = $("#SchedulerInfoSuppressFrom").data("kendoTimePicker").element[0].value;
            e.model.SchedulerInfoSuppressTo = $("#SchedulerInfoSuppressTo").data("kendoTimePicker").element[0].value;
            e.model.TestAlarmMoment = $("#TestAlarmMoment").data("kendoTimePicker").element[0].value;

            if (e.model.OccupancyInfo) {
                e.model.Group1 = $("#Group1").data("kendoDropDownList").element[0].value;
                e.model.Group2 = $("#Group2").data("kendoDropDownList").element[0].value;
            }

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl(e.model.FormAction),
                data: e.model,
                success: function (responseData) {
                    form.showServerResponse(responseData);
                }
            });
        },

        /**
        * Field Understaffed at night changed. Set some fields hidden accordingly
        * @param {Object} e
        */
        underStaffedNotAtNightChanged: function (e) {
            main.setHideKendoUIFormItem4("SchedulerInfoSuppressFrom", e.checked);
            main.setHideKendoUIFormItem4("SchedulerInfoSuppressTo", e.checked);
        },

        /**
        * Field OccupancyInfo is changed. Set some fields hidden accordingly
        * @param {Object} e
        */
        occupancyInfoChanged: function (e) {
            main.setHideKendoUIFormItem4("Group1", e.checked);
            main.setHideKendoUIFormItem4("Group2", e.checked);
        },

        /**
        * Field UseConcanated is changed. Set some fields hidden accordingly
        * @param {Object} e
        */
        useConcatenatedChanged: function (e) {
            main.setHideKendoUIFormItem4("ConcatenatedMessageTime", e.checked);
            main.setHideKendoUIFormItem5("LUnitConcatenatedMessageTime", e.checked);
        },

        combinedGroupChanged: function (e) {
            main.setHideKendoUIFormItem4("CombinedGroupTime", e.checked);
            main.setHideKendoUIFormItem5("LUnitCombinedGroupTime", e.checked);
        },

        /**
        * Field TestAlarmDay is changed. Set some fields hidden accordingly
        * @param {Object} e
        */
        testAlarmDayChanged: function (e) {
            main.setHideKendoUIFormItem4("TestAlarmMoment", e.sender.element[0].value !== '0');
            main.setHideKendoUIFormItem4("TestAlarmText", e.sender.element[0].value !== '0');
        },

        /**
        * Visibility Tab General 
        */
        visibility_Tab_General: function () {
                        
            var cb_oi = $("#OccupancyInfo").data("kendoCheckBox");
            if (cb_oi != null && cb_oi != undefined) {
                main.setHideKendoUIFormItem4("Group1", cb_oi.options.checked);
                main.setHideKendoUIFormItem4("Group2", cb_oi.options.checked);
            }

            var cb_ucm = $("#UseConcatenatedMessage").data("kendoCheckBox");
            if (cb_ucm != null && cb_ucm != undefined) {
                main.setHideKendoUIFormItem4("ConcatenatedMessageTime", cb_ucm.options.checked);
                main.setHideKendoUIFormItem5("LUnitConcatenatedMessageTime", cb_ucm.options.checked);
            }

            var cb_cg = $("#CombinedGroup").data("kendoCheckBox");
            if (cb_cg != null && cb_cg != undefined) {
                main.setHideKendoUIFormItem4("CombinedGroupTime", cb_cg.options.checked);
                main.setHideKendoUIFormItem5("LUnitCombinedGroupTime", cb_cg.options.checked);
            }

            var cb_sis = $("#SchedulerInfoSuppress").data("kendoCheckBox");
            if (cb_sis != null && cb_sis != undefined) {
                main.setHideKendoUIFormItem4("SchedulerInfoSuppressFrom", cb_sis.options.checked);
                main.setHideKendoUIFormItem4("SchedulerInfoSuppressTo", cb_sis.options.checked);
            }

            var cbb = $("#TestAlarmDay").data("kendoDropDownList");
            if (cbb != null && cbb != undefined) {
                main.setHideKendoUIFormItem4("TestAlarmMoment", cbb.element[0].value !== '0');
                main.setHideKendoUIFormItem4("TestAlarmText", cbb.element[0].value !== '0');
            }
        },

        //--- TAB Users --------------------------------------------------------------------------------------------------------------//

        /**
        * Init tab users
        */
        TAB_Users_initialize: function (notsaved) {
            _msg_notsaved = notsaved;       

            $("#notSelectedSearchBox").on("input", function (e) {
                var listBox = $("#GroupConfiguration_UserOccupancy_CplNotSelected").getKendoListBox();
                var searchString = $(this).val();

                listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
            });

            $("#selectedSearchBox").on("input", function (e) {
                var listBox = $("#GroupConfiguration_UserOccupancy_CplSelected").getKendoListBox();
                var searchString = $(this).val();

                listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
            });
        },

        /**
        * Return label changed not saved
        */
        TAB_Users_Get_LDataChangedNotSavedYet: function () {
            return _msg_notsaved;
        },

        /**
        * Move user to the left
        */
        TAB_Users_leftClicked: function () {
            groupconfiguration.TAB_Users_enableSaveButton();
            listbox.moveItems("GroupConfiguration_UserOccupancy_CplSelected", "GroupConfiguration_UserOccupancy_CplNotSelected", "#Users_Validation", groupconfiguration.TAB_Users_Get_LDataChangedNotSavedYet)
        },

        /**
        * Move user to the right
        */
        TAB_Users_rightClicked: function () {
            groupconfiguration.TAB_Users_enableSaveButton();
            listbox.moveItems("GroupConfiguration_UserOccupancy_CplNotSelected", "GroupConfiguration_UserOccupancy_CplSelected", "#Users_Validation", groupconfiguration.TAB_Users_Get_LDataChangedNotSavedYet)
        },

        /**
        * Enable save button
        */
        TAB_Users_enableSaveButton: function () {
            var btnSave = document.getElementById("saveButtonUsers");
            btnSave.removeAttribute("disabled");
        },

        /**
        * Save button clicked
        */
        TAB_Users_saveButtonClicked: function (actionUrl, groupId) {

            var listBox = $("#GroupConfiguration_UserOccupancy_CplSelected").getKendoListBox();
            listBox.dataSource.filter({ field: "Text", operator: "contains", value: "" });

            var json = listBox.dataSource.view();
            var list = json.slice();

            $.ajax({
                type: "POST",
                url: appsettings.getUrl(actionUrl),
                data: { list: kendo.stringify(list), groupId: groupId },
                success: function (responseData) {

                    $('#Users_Validation').text("");

                    $("#TableOccupancyLR").load(appsettings.getUrl("Group/GetOccupancyLR?groupId=" + groupId));

                    $("#TableOccupancyInfo").load(appsettings.getUrl("Group/GetOccupancyInfo?groupId=" + groupId));

                    var color = (responseData.Success ? 'green' : 'red');
                    $('#Users_Validation').text(responseData.Message);
                    $('#Users_Validation').attr('style', 'color:' + color);
                }
            });
        },

        /**
        * Get Occupancy for the left and right.
        * @param {number} groupId
        */
        TAB_Users_occupancyLR: function (groupId) {
            $("#TableOccupancyLR").load(appsettings.getUrl("Group/GetOccupancyLR?groupId=" + groupId), function () { 
                viewmode.applyViewMode("TableOccupancyLR");
            });
        },

        /**
        * Get Occupancy information
        * @param {number} groupId
        */
        TAB_Users_occupancyInfo: function (groupId) {
            $("#TableOccupancyInfo").load(appsettings.getUrl("Group/GetOccupancyInfo?groupId=" + groupId), function () {
                viewmode.applyViewMode("TableOccupancyInfo");
            });
        },


        TAB_Users_OccupancyCBChanged: function () {
            main.setHideDiv("UsersCB_Validation_Above", true);
            main.setHideDiv("UsersCB_Validation_Below", true);
            $("#formGroupUserOccupancy_submitForm").removeAttr("disabled");
        },

        /**
        * Initialize tab users 
        * @param {Object} model
        */
        TAB_Users_occupancyInfo_initialize: function () {

            $("#formGroupUserOccupancy_submitForm").attr("disabled", "disabled");

            main.setHideDiv("UsersCB_Validation_Above", false);
            $("#UsersCB_Validation_Above").html(groupconfiguration.TAB_Users_Get_LDataChangedNotSavedYet).text();

            main.setHideDiv("UsersCB_Validation_Below", false);
            $("#UsersCB_Validation_Below").html(groupconfiguration.TAB_Users_Get_LDataChangedNotSavedYet).text();
        },

        //--- Vehicle ----------------------------------------------------------------------------------------------//

        /**
        * Initialize the verhicle tab
        */
        TAB_Vehicle_initialize: function () {
        },

        /**
        * Get the selected verhicles for the current selected group
        * @param {string} groupId
        */
        TAB_Vehicle_LV: function (groupId) {
            $("#TabVehicleLV").load(appsettings.getUrl("Group/GetSelectedVehicles?groupId=" + groupId));
        },

        /**
        * Vehicle input changed
        */
        TAB_Vehicle_inputChanged: function () {
            var btnAdd = document.getElementById("GroupConfiguration_Vehicle_add-button");
            btnAdd.removeAttribute("disabled");
        },

        /**
        * Vehicle input changed
        */
        TAB_Vehicle_enableDeleteButton: function () {
            var btnDelete = document.getElementById("GroupConfiguration_Vehicle_delete-button");
            btnDelete.removeAttribute("disabled");
        },

        /**
        * Vehicle add clicked
        * @param {number} groupId
        */
        TAB_Vehicle_addClicked: function (groupId) {

            var inp = document.getElementById("TBVehicle");

            if (inp != undefined) {

                // Post Data
                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl("Group/AddVehicleToGroup"),
                    data: { label: inp.value, groupId: groupId },
                    success: function (responseData) {
                        // refresh list
                        groupconfiguration.TAB_Vehicle_reloadListView(groupId);

                        if (responseData != undefined && responseData != null) {

                            if (responseData.Succesfully == false) {
                                main.openActionsDialog(' ', responseData.Message,
                                    [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                            } else {
                                // clear add field
                                document.getElementById("TBVehicle").value = "";

                                // disable Add button
                                document.getElementById("GroupConfiguration_Vehicle_add-button").setAttribute("disabled", "disabled");
                            }
                        }
                    }
                });
            }
        },

        /**
        * Vehicle delete clicked event handler for the are you sure message
        * @param {number} groupId
        * @param {string} questionMessage
        * @param {string} yesText
        * @param {string} noText
        */
        TAB_Vehicle_deleteClicked: function (groupId, questionMessage, yesText, noText) {
            main.openActionsDialog(' ', questionMessage,
                [ { text: yesText, action: function () { groupconfiguration.TAB_Vehicle_removeVehicle(groupId); main.closePopup(); } },
                  { text: noText,  action: function () { main.closePopup(); }} ]);
        },


        /**
        * Vehicle reload listview
        * @param {number} groupId
        */
        TAB_Vehicle_reloadListView: function (groupId) {
            // Get Data
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("Group/LoadVehicles"),
                data: { groupId: groupId },
                success: function (responseData) {
                    if (responseData != undefined) {
                        var listView = $("#GroupConfiguration_Vehicle_CplSelected").data("kendoListBox");
                        listView.dataSource.data(responseData.items);
                    }
                }
            });
        },

        /**
        * Vehicle remove vehicle from listview
        * @param {number} groupId
        */
        TAB_Vehicle_removeVehicle: function (groupId) {

            var vehiclesArr = [];

            var listView = $("#GroupConfiguration_Vehicle_CplSelected").data("kendoListBox");

            if (listView != undefined) {

                var items = listView.select();
                var allitems = listView.items();

                for (var cnt = 0; cnt < items.length; cnt++) {
                    var idx = allitems.index(items[cnt]);
                    var dataItem = listView.dataSource.view()[idx];
                    vehiclesArr[cnt] = parseInt(dataItem.Value);
                }
            }

            var list = vehiclesArr.slice();

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("Group/RemoveVehiclesFromGroup"),
                data: { list: kendo.stringify(list), groupId: groupId },
                success: function (responseData) {

                    // refresh list
                    groupconfiguration.TAB_Vehicle_reloadListView(groupId);

                    if (responseData != undefined && responseData != null) {

                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        } else {

                            // disable delete button
                            document.getElementById("GroupConfiguration_Vehicle_delete-button").setAttribute("disabled", "disabled");
                        }
                    }

                }
            });
        },


        //--- Functions ----------------------------------------------------------------------------------------------------//

        /**
        * Tab: Functions, initialize with message 'not saved'
        * @param {string} notsaved
        */
        TAB_Functions_initialize: function (notsaved) {
            _msg_notsaved = notsaved;

            $("#notSelectedSearchBox").on("input", function (e) {
                var listBox = $("#GroupConfiguration_Functions_CplNotSelected").getKendoListBox();
                var searchString = $(this).val();

                listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
            });

            $("#selectedSearchBox").on("input", function (e) {
                var listBox = $("#GroupConfiguration_Functions_CplSelected").getKendoListBox();
                var searchString = $(this).val();

                listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
            });
        },

        /**
        * Tab: Functions, return message 'not saved'
        * @param {string} notsaved
        */
        TAB_Functions_Get_LDataChangedNotSavedYet: function () {
            return _msg_notsaved;
        },

        /**
        * Tab: Functions, move selected items from the right to the left
        * @param {Object} listA
        * @param {Object} listB
        */
        TAB_Functions_leftClicked: function () {
            groupconfiguration.TAB_Functions_enableSaveButton();
            listbox.moveItems("GroupConfiguration_Functions_CplSelected", "GroupConfiguration_Functions_CplNotSelected", "#Functions_Validation", groupconfiguration.TAB_Functions_Get_LDataChangedNotSavedYet);
        },

        /**
        * Tab: Functions, move selected items from the left to the right
        */
        TAB_Functions_rightClicked: function () {
            groupconfiguration.TAB_Functions_enableSaveButton();
            listbox.moveItems("GroupConfiguration_Functions_CplNotSelected", "GroupConfiguration_Functions_CplSelected", "#Functions_Validation", groupconfiguration.TAB_Functions_Get_LDataChangedNotSavedYet);
        },

        /**
        * Tab: Functions, enable save button 
        */
        TAB_Functions_enableSaveButton: function () {
            var btnSave = document.getElementById("saveButtonFunctions");
            btnSave.removeAttribute("disabled");
        },

        /**
        * Tab: Functions, move selected items from the right to the left
        * @param {Object} actionUrl
        * @param {Object} groupId
        */
        TAB_Functions_saveButtonClicked: function (actionUrl, groupId) {
            groupconfiguration.TAB_Functions_Save(actionUrl, groupId);
            groupconfiguration.TAB_Functions_Trainee_Save();
        },

        TAB_Functions_Save: function (actionUrl, groupId) {

            var listBox = $("#GroupConfiguration_Functions_CplSelected").getKendoListBox();
            listBox.dataSource.filter({ field: "Text", operator: "contains", value: "" });

            var json = listBox.dataSource.view();
            var list = json.slice();

            $.ajax({
                type: "POST",
                url: appsettings.getUrl(actionUrl),
                data: { list: kendo.stringify(list), groupId: groupId },
                success: function (responseData) {

                    $('#Functions_Validation').text("");

                    var color = (responseData.Success ? 'green' : 'red');
                    $('#Functions_Validation').text(responseData.Message);
                    $('#Functions_Validation').attr('style', 'color:' + color);

                    $("#editTabstripGroup").data("kendoTabStrip").reload(".k-active");
                }
            });
        },

        /**
        * Tab: Functions, Up click event
        */
        TAB_Functions_upClicked: function () {
            var list = $("#GroupConfiguration_Functions_CplSelected").data("kendoListBox");
            groupconfiguration.TAB_Functions_moveUpDown(list, -1);
        },

        /**
        * Tab: Functions, Down click event
        */
        TAB_Functions_downClicked: function () {
            var list = $("#GroupConfiguration_Functions_CplSelected").data("kendoListBox");
            groupconfiguration.TAB_Functions_moveUpDown(list, 1);
        },

        /**
        * Tab: Functions, sync 
        * @param {Object} list
        * @param {Object} indexModifier
        */
        TAB_Functions_moveUpDown: function (list, indexModifier) {
            var items = list.items();
            var selected = list.select();

            if (selected.length === 1) {
                selected = selected[0];
                var index = items.index(selected);
                var item = list.dataSource.view()[index];
                if (indexModifier === 1 && index < items.length - 1
                    || indexModifier === -1 && index > 0) {
                    list.dataSource.remove(item);
                    list.dataSource.insert(index + indexModifier, item);
                    list.select(list.items()[index + indexModifier]);
                }
            }

            $("#Functions_Validation").attr("style", "color:red");
            $("#Functions_Validation").html(groupconfiguration.TAB_Functions_Get_LDataChangedNotSavedYet).text();

            groupconfiguration.TAB_Functions_enableSaveButton();
        },

        TAB_Functions_OnSelect: function (groupId, e) {
            main.setHideDivBootstrap("PTrainee", false);

            // check we are not in a "Data changed but not saved yet" situation
            if ($("#Functions_Validation").text() == '') {    

                var element = e.sender.select();
                var selectedGroupServiceFunction = e.sender.dataItem(element[0]);

                // Get Data
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("Group/GetFunctionTrainee"),
                    data: { groupId: groupId, serviceFunctionId: selectedGroupServiceFunction.Value },
                    success: function (responseData) {
                        if (responseData != undefined) {
                            var cb = $("#CBTrainee")[0];
                            if (cb != null && cb != undefined) {
                                cb.checked = responseData.Trainee;
                                cb.name = responseData.GroupServiceFunctionID;

                                //cb.prop('checked', responseData.Trainee)
                                //cb.attr("name", responseData.GroupServiceFunctionID);

                                //.data("kendoCheckBox")
                                //cb.value()                            
                            }

                            var cbLabel = $("#LTrainee")[0];
                            if (cbLabel != null && cbLabel != undefined) {
                                cbLabel.innerHTML = selectedGroupServiceFunction.Text;

                                //cbLabel.text(selectedGroupServiceFunction.Text);
                            }

                            main.setHideDivBootstrap("PTrainee", true);
                            groupconfiguration.TAB_Functions_enableSaveButton();
                        }
                    }
                });
            }
        },

        TAB_Functions_Trainee_Save: function () {
            var cb = $("#CBTrainee")[0];
            if (!$("#PTrainee").hasClass('d-none') && cb != null && cb != undefined) {
                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl("Group/UpdateFunctionTrainee"),
                    data: { groupServiceFunctionId: cb.name, enable: cb.checked },
                    success: function (responseData) {

                        $('#Functions_Validation').text("");

                        var color = (responseData.Success ? 'green' : 'red');
                        $('#Functions_Validation').text(responseData.Message);
                        $('#Functions_Validation').attr('style', 'color:' + color);

                        $("#editTabstripGroup").data("kendoTabStrip").reload(".k-active");
                    }
                });
            }
        },

        //--- MINIMAL OCCUPANCY --------------------------------------------------------------------------------------------------------//

        /**
        * MinimalOccupation input changed
        */
        TAB_MinimalOccupation_init: function (highText, lowText) {

            MIN_OCCUPANCY_HIGH = highText;
            MIN_OCCUPANCY_LOW = lowText;

            var cbb = $("#CustomOccupancyMinMax").data("kendoDropDownList");
            if (cbb != null && cbb != undefined) {
                var hltxt = document.getElementById("DivHighLowText");

                switch (cbb.value()) {

                    case '0':
                        hltxt.innerHTML = "";
                        cbb.value('');
                        break;

                    case '1':
                        hltxt.innerHTML = MIN_OCCUPANCY_HIGH;
                        break;

                    case '2':
                        hltxt.innerHTML = MIN_OCCUPANCY_LOW;
                        break;
                }
            }

            if ($("#CustomOccupancy").data("kendoCheckBox").value()) {
                $(".CustomDispatch").show();
            } else {
                $(".CustomDispatch").hide();
            }
        },


        TAB_MinimalOccupation_setHighLowText: function (e) {

            var hltxt = document.getElementById("DivHighLowText");

            switch (e.sender.element[0].value) {

                case '':
                    hltxt.innerHTML = "";
                    break;

                case '1':
                    hltxt.innerHTML = MIN_OCCUPANCY_HIGH;
                    break;

                case '2':
                    hltxt.innerHTML = MIN_OCCUPANCY_LOW;
                    break;
            }
        },


        /**
        * Minimal occupation delete clicked event handler for the are you sure message
        * @param {object} e
        */
        TAB_MinimalOccupation_customDispatch: function (e) {

            if (e.checked) {
                $(".CustomDispatch").show();
            }
            else {
                $(".CustomDispatch").hide();
            }

        },

        /**
        * Minimal occupation reload listview
        * @param {number} groupId
        */
        TAB_MinimalOccupation_reloadListView: function (groupId) {
            // Get Data
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("Group/LoadTextForMaxOccupancy"),
                data: { groupId: groupId },
                success: function (responseData) {
                    if (responseData != undefined) {
                        var listView = $("#GroupConfiguration_MinimalOccupation_CplSelected").data("kendoListBox");
                        listView.dataSource.data(responseData.items);
                    }
                }
            });
        },

        /**
        * MinimalOccupation input changed
        */
        TAB_MinimalOccupation_enableDeleteButton: function () {
            var btnDelete = document.getElementById("GroupConfiguration_MinimalOccupation_delete-button");
            btnDelete.removeAttribute("disabled");
        },

        /**
        * MinimalOccupation input changed
        */
        TAB_MinimalOccupation_inputChanged: function () {
            var btnAdd = document.getElementById("GroupConfiguration_MinimalOccupation_add-button");
            btnAdd.removeAttribute("disabled");
        },

        /**
        * Vehicle delete clicked event handler for the are you sure message
        * @param {number} groupId
        * @param {string} questionMessage
        * @param {string} yesText
        * @param {string} noText
        */
        TAB_MinimalOccupation_deleteClicked: function (groupId, questionMessage, yesText, noText) {
            main.openActionsDialog(' ', questionMessage,
                [{ text: yesText, action: function () { groupconfiguration.TAB_MinimalOccupation_removeMinimalOccupation(groupId); main.closePopup(); } },
                { text: noText, action: function () { main.closePopup(); } }]);
        },

        /**
        * MinimalOccupation add clicked
        * @param {number} groupId
        */
        TAB_MinimalOccupation_addClicked: function (groupId) {
        
            var inp = document.getElementById("TBMinimalOccupation");

            if (inp != undefined) {

                // Post Data
                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl("Group/AddTextForMaxOccupancy"),
                    data: { Label: inp.value, GroupId: groupId },
                    success: function (responseData) {
                        // refresh list
                        groupconfiguration.TAB_MinimalOccupation_reloadListView(groupId);

                        if (responseData != undefined && responseData != null) {

                            if (responseData.Succesfully == false) {
                                main.openActionsDialog(' ', responseData.Message,
                                    [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                            } else {
                                // clear add field
                                document.getElementById("TBMinimalOccupation").value = "";

                                // disable Add button
                                document.getElementById("GroupConfiguration_MinimalOccupation_add-button").setAttribute("disabled", "disabled");
                            }
                        }
                    }
                });
            }
        },

        /**
        * MinimalOccupation remove vehicle from listview
        * @param {number} groupId
        */
        TAB_MinimalOccupation_removeMinimalOccupation: function (groupId) {

            var vehiclesArr = [];

            var listView = $("#GroupConfiguration_MinimalOccupation_CplSelected").data("kendoListBox");

            if (listView != undefined) {

                var items = listView.select();
                var allitems = listView.items();

                for (var cnt = 0; cnt < items.length; cnt++) {
                    var idx = allitems.index(items[cnt]);
                    var dataItem = listView.dataSource.view()[idx];
                    vehiclesArr[cnt] = parseInt(dataItem.Value);
                }
            }

            var list = vehiclesArr.slice();

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("Group/RemoveMinimalOccupationFromGroup"),
                data: { list: kendo.stringify(list), groupId: groupId },
                success: function (responseData) {

                    // refresh list
                    groupconfiguration.TAB_MinimalOccupation_reloadListView(groupId);

                    if (responseData != undefined && responseData != null) {

                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        } else {

                            // disable delete button
                            document.getElementById("GroupConfiguration_MinimalOccupation_delete-button").setAttribute("disabled", "disabled");
                        }
                    }

                }
            });
        },

        TAB_MinimalOccupation_SaveSettings: function () {

            var post_data = new Object();

            // Additional Settings
            post_data.SelectedGroupId = $("#selectedGroupId").val();
            post_data.CustomOccupancy = $("#CustomOccupancy").data("kendoCheckBox").value();
            post_data.IsMaxOccupationDesired = $("#IsMaxOccupationDesired").data("kendoCheckBox").value();
            post_data.CustomOccupancyMinMax = $("#CustomOccupancyMinMax").data("kendoDropDownList").value();

            // Get all the rows
            var vehicles = $(".vehicle-settings-row");

            // Create a object that is a array with objects
            post_data.VehicleSettings = new Array();

            // Loop through the rows
            for (var i = 0; i < vehicles.length; i++) {

                // Get the vehicle id 'hidden input'
                var vehicleId = $(vehicles[i]).find(".vehicleid").first().val();

                // Create vehicle object
                var vehicle = new Object();
                vehicle.Id = parseInt(vehicleId);
                vehicle.Label = "vehicle" + i;
                vehicle.IsAvailable = $("#vehicle_" + vehicleId + "_active").data("kendoCheckBox").value();
                vehicle.SettingsMinMax = new Array();
                post_data.VehicleSettings.push(vehicle);

                // get all columns min max from the row 'vehicle'
                var columns = $(vehicles[i]).find(".funtion-settings-col");

                for (var j = 0; j < columns.length; j++) {
                    // get identifiers to query the values from the kendo numeric textbox. hidden inputs
                    var groupVehicleId = $(columns[j]).find(".groupVehicleId").first().val();
                    var groupServiceFunctionId = $(columns[j]).find(".groupServiceFunctionId").first().val();

                    // get the values 
                    var min_value = $("#" + groupVehicleId + "_" + groupServiceFunctionId + "_min").data("kendoNumericTextBox").value();
                    var max_value = $("#" + groupVehicleId + "_" + groupServiceFunctionId + "_max").data("kendoNumericTextBox").value();

                    // add new object
                    var min_max_setting = new Object();
                    min_max_setting.GroupVehicleId = parseInt(groupVehicleId);
                    min_max_setting.GroupServiceFunctionId = parseInt(groupServiceFunctionId);
                    min_max_setting.Label = "vehicle" + i + "_function_" + j;
                    min_max_setting.Min = min_value;
                    min_max_setting.Max = max_value;
                    post_data.VehicleSettings[i].SettingsMinMax.push(min_max_setting)
                }
            }

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("Group/Tab_MinOccupation_SaveSettings"),
                data: post_data,

                success: function (responseData) {
                    // Show request result
                    form.showServerResponse("dynamicform_group_min_occupancy", responseData);

                    if (responseData.Succesfully) {
                        setTimeout(function () { $("#editTabstripGroup").data("kendoTabStrip").reload(".k-active") }, 2500);
                    }
                }
            });

        },

        //--- MINIMAL OCCUPANCY --------------------------------------------------------------------------------------------------------//


        //--- CAPCODE --------------------------------------------------------------------------------------------------------//

        /**
        * Tab: Capcode initialize
        */
        TAB_CapCode_initialize: function () {
        },

        /**
        * Tab: Capcode, get selected capcodes 
        * @param {number} groupId
        */
        TAB_CapCode_LV: function (groupId) {
            $("#TabCapCodeLV").load(appsettings.getUrl("Group/GetSelectedCapCodes?groupId=" + groupId));
        },

        /**
        * Tab: Capcode, get selected Capcodes for vehicles 
        * @param {number} groupId
        */
        TAB_CapCode_Vehicle: function (groupId) {
            $("#TabCapCodeVehicle").load(appsettings.getUrl("Group/GetSelectedCapCodesVehicles?groupId=" + groupId));
        },

        /**
        * Tab: Capcode, Add capcode -> enable button
        */
        TAB_CapCode_inputChanged: function () {
            var btnAdd = document.getElementById("GroupConfiguration_CapCode_add-button");
            btnAdd.removeAttribute("disabled");
        },

        /**
        * Tab: Capcode, Delete capcode -> enable button
        */
        TAB_CapCode_enableDeleteButton: function () {
            var btnDelete = document.getElementById("GroupConfiguration_CapCode_delete-button");
            btnDelete.removeAttribute("disabled");
        },

        /**
        * Tab: Capcode, Add click 
        * @param {number} groupId
        */
        TAB_CapCode_addClicked: function (groupId) {

            var inp = document.getElementById("TBCapCode");

            if (inp != undefined) {

                // Post Data
                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl("Group/AddCapCodeToGroup"),
                    data: { capcode: inp.value, groupId: groupId },
                    success: function (responseData) {

                        // refresh active capcodes per vehicle 
                        $("#TabCapCodeVehicle").load(appsettings.getUrl("Group/GetSelectedCapCodesVehicles?groupId=" + groupId));

                        if (responseData != undefined && responseData != null) {

                            if (responseData.Succesfully == false) {
                                main.openActionsDialog(' ', responseData.Message,
                                    [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                            } else {

                                // clear add field
                                $("#TBCapCode").data("kendoNumericTextBox").value("");

                                // disable Add button
                                document.getElementById("GroupConfiguration_CapCode_add-button").setAttribute("disabled", "disabled");

                                // update listview
                                groupconfiguration.TAB_CapCode_reloadListView(groupId);
                            }
                        }
                    }
                });
            }
        },

        /**
        * Tab: Capcode, reload listviews by groupid 
        * @param {number} groupId
        */
        TAB_CapCode_reloadListView: function (groupId) {
            // Get Data
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("Group/LoadCapcodes"),
                data: { groupId: groupId },
                success: function (responseData) {
                    if (responseData != undefined) {
                        var listView = $("#GroupConfiguration_CapCode_CplSelected").data("kendoListBox");
                        listView.dataSource.data(responseData.items);
                    }
                }
            });
        },

        /**
        * Tab: Capcode, Delete confirm 
        * @param {number} groupId
        * @param {string} questionMessage
        * @param {string} yesText
        * @param {string} noText
        */
        TAB_CapCode_deleteClicked: function (groupId, questionMessage, yesText, noText) {

            main.openActionsDialog(' ', questionMessage,
                [{ text: yesText, action: function () { groupconfiguration.TAB_CapCode_removeVehicle(groupId); main.closePopup(); } },
                { text: noText, action: function () { main.closePopup(); } }]);
        },

        /**
        * Tab: Capcode, Delete vehicle 
        * @param {number} groupId 
        */
        TAB_CapCode_removeVehicle: function (groupId) {

            var capcodesArr = [];

            var listView = $("#GroupConfiguration_CapCode_CplSelected").data("kendoListBox");

            if (listView != undefined) {

                var items = listView.select();
                var allitems = listView.items();

                for (var cnt = 0; cnt < items.length; cnt++) {
                    var idx = allitems.index(items[cnt]);
                    var dataItem = listView.dataSource.view()[idx];
                    capcodesArr[cnt] = parseInt(dataItem.Text);
                }
            }

            var list = capcodesArr.slice();

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("Group/RemoveCapCodesFromGroup"),
                data: { list: kendo.stringify(list), groupId: groupId },
                success: function (responseData) {

                    groupconfiguration.TAB_CapCode_reloadListView(groupId);

                    $("#TabCapCodeVehicle").load(appsettings.getUrl("Group/GetSelectedCapCodesVehicles?groupId=" + groupId));

                    if (responseData != undefined && responseData != null) {

                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        } else {

                            // disable delete button
                            document.getElementById("GroupConfiguration_CapCode_delete-button").setAttribute("disabled", "disabled");
                        }
                    }

                }
            });
        },

        /**
        * Tab Capcode: Visibility vehicle capcodes
        * @param {boolean} visible 
        */
        TAB_CapCode_setVisibilityVehicleCapCodes: function (visible) {

            var element = document.getElementById("divVehicleCapCodes");

            if (element !== undefined && element !== null) {

                if (visible) {
                    element.style.display = "block";  // "inline";
                } else {
                    element.style.display = "none";
                }
            }
        },

        /**
        * Tab Capcode: get capcodes
        * @param {number} groupId 
        * @param {Object} e 
        */
        TAB_CapCode_GetCapCodesCbs: function (groupId, e) {

            // Get
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("Group/GetCapCodesCbs"),
                data: { groupId: groupId, groupVehicleId: e.sender.element[0].value },
                success: function (responseData) {
                    $("#checkboxgroup").data("kendoCheckBoxGroup").value(responseData.capcodeArr);
                }
            });

        },

        /**
        * Tab Capcode: save checkbox groups
        * @param {number} groupId 
        * @param {number} vehicleId 
        * @param {Object} e 
        */
        TAB_CapCode_SaveCheckBoxGroup: function (groupId, vehicleId, e) {

            var vehicles = [];

            var checkboxes = $("#checkboxgroup").data("kendoCheckBoxGroup").value();

            for (var i = 0; i < checkboxes.length; i++) {
                vehicles[i] = parseInt(checkboxes[i]);
            }

            var list = vehicles.slice();

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("Group/SaveCheckBoxGroupValues"),
                data: { list: kendo.stringify(list), groupId: groupId, vehicleId: vehicleId },
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }
                }
            });
        },


        //--- TAB_PATTERN -----------------------------------------------------------------------------

        TAB_Pattern_Initialize: function (groupId, labelYes, labelNo, labelDelete) {

            // Add
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("Group/AddPattern?groupId=" + groupId);
            });

            LABEL_YES = labelYes;
            LABEL_NO = labelNo;
            LABEL_DELETE = labelDelete;
        },

        TAB_Pattern_ShowItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Show mode form 
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Group/ShowPattern?patternId=" + dataItem.PatternID + "&breadcrumbLabel=" + escape(dataItem.Label));
        },

        TAB_Pattern_EditItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Edit mode form 
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Group/EditPattern?patternId=" + dataItem.PatternID + "&breadcrumbLabel=" + escape(dataItem.Label));
        },

        TAB_Pattern_DeleteItem: function (e) {

            e.preventDefault();

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            main.openActionsDialog(' ', LABEL_DELETE + ' ' + dataItem.Label + ' ?',
                [{ text: LABEL_YES, action: function () { groupconfiguration.TAB_Pattern_DeletePattern(dataItem.PatternID, dataItem.GroupID); main.closePopup(); } },
                { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
        },

        TAB_Pattern_DeletePattern: function (patternId, groupId) {
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("Group/DeletePattern?patternId=" + patternId),
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }

                    navigation.navigateToSpecificUrl("Group/Tab_Pattern?groupId=" + groupId);
                }
            });
        },


        //--- TAB_CREW ----------------------------------------------------------------

        TAB_Crew_Initialize: function (groupId, labelYes, labelNo, labelDelete) {

            // Add
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("Group/AddCrewname?groupId=" + groupId);
            });

            LABEL_YES = labelYes;
            LABEL_NO = labelNo;
            LABEL_DELETE = labelDelete;
        },
        

        TAB_Crew_ShowItem: function (e) {
            // Prevent default behaviour
            e.preventDefault();

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Show mode form
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Group/Show_Crewname?ploegnaamId=" + dataItem.PloegnaamID + "&breadcrumbLabel=" + escape(dataItem.Label));
        },


        TAB_Crew_EditItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Edit mode form
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Group/Edit_Crewname?ploegnaamId=" + dataItem.PloegnaamID + "&breadcrumbLabel=" + escape(dataItem.Label));
        },


        TAB_Crew_deleteClicked: function (e) {

            e.preventDefault();

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            main.openActionsDialog(' ', LABEL_DELETE + ' ' + dataItem.Label + ' ?',
                [{ text: LABEL_YES, action: function () { groupconfiguration.TAB_Crew_DeleteItem(dataItem.PloegnaamID, dataItem.GroupID); main.closePopup(); } },
                { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
        },


        TAB_Crew_DeleteItem: function (ploegnaamId, groupId) {

            $.ajax({
                type: "GET",
                url: appsettings.getUrl("Group/DeleteCrewname?ploegnaamId=" + ploegnaamId),
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }

                    navigation.navigateToSpecificUrl("Group/Tab_Crew?groupId=" + groupId);
                }
            });
        },

    }

}();